import { render } from "./TicketOnProcess.vue?vue&type=template&id=34dbec39&scoped=true"
import script from "./TicketOnProcess.vue?vue&type=script&lang=js"
export * from "./TicketOnProcess.vue?vue&type=script&lang=js"

import "./TicketOnProcess.vue?vue&type=style&index=0&id=34dbec39&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34dbec39"

export default script